import { StoreAccessor, GetDocs, AddSchema } from "mobx-firelink";
export class RecentAction {
}
AddSchema("RecentAction", {
    properties: {
        title: { type: "string" },
        undone: { type: "boolean" },
    },
});
export const GetRecentActions = StoreAccessor("GetRecentActions", s => (userID) => {
    if (userID == null)
        return [];
    return GetDocs({}, a => a.userExtras.get(userID).recentActions);
});
export const GetRecentAction = StoreAccessor("GetRecentAction", s => (userID, actionID) => {
    //return GetData("userExtras", userID, "recentActions", actionID);
    return GetRecentActions(userID).find(a => a && a._id == actionID);
});
export const GetUndoAction = StoreAccessor("GetUndoAction", s => (userID) => {
    const actions = GetRecentActions(userID);
    return actions.LastOrX(a => a && !a.undone);
});
export const GetRedoAction = StoreAccessor("GetRedoAction", s => (userID) => {
    const actions = GetRecentActions(userID);
    return actions.FirstOrX(a => a && a.undone);
});
